import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { createOrganization as _createOrganization, defaultOrganization, getOrganizationList, getTherapistListByOrg as _getTherapistListByOrg, toRoleTypeNormal, toRoleTypeOwner, updateOrganization } from '@/api/organization';
import { trim } from 'tinymce';
import { cloneDeep } from 'lodash';
import Pagination from '@/components/Pagination/index.vue';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "organizationList", []);
    _defineProperty(_this, "orgListLoading", true);
    _defineProperty(_this, "typeOptions", [{
      key: 'HOSPITAL',
      display: 'Hospital'
    }, {
      key: 'CLINIC',
      display: 'Clinic'
    }]);
    _defineProperty(_this, "useYnOptions", [{
      key: true,
      display: 'Y'
    }, {
      key: false,
      display: 'N'
    }]);
    _defineProperty(_this, "dialogAddOrgVisible", false);
    _defineProperty(_this, "dialogMngOwnerVisible", false);
    _defineProperty(_this, "tempOrganization", defaultOrganization);
    // Form Clinic Code 검증을 위한 Validator 21.02.01
    _defineProperty(_this, "validateClinicCode", function (rule, value, callback) {
      var regExpIsClincCode = /^(?=.*[A-Z])(?=.*\d)[A-Z\d]/;
      if (value === '') {
        callback(new Error('Clinic Code is required'));
      } else if (!regExpIsClincCode.test(value)) {
        callback(new Error('Clinic code must be entered in capital letters and digit.'));
      } else if (value.length !== 6) {
        callback(new Error('Clinic Code Length must be 6'));
      } else {
        callback();
      }
    });
    // Form Validator rules 21.02.01
    _defineProperty(_this, "rules", {
      name: [{
        required: true,
        message: 'Name is required',
        trigger: 'blur'
      }, {
        min: 3,
        max: 100,
        message: 'Length should be 3 to 100',
        trigger: 'blur'
      }],
      type: [{
        required: true,
        message: 'Type is required',
        trigger: 'change'
      }],
      clinicCode: [{
        required: true,
        validator: _this.validateClinicCode,
        trigger: 'blur'
      }],
      useYn: [{
        required: true,
        message: 'Use Y/N is required',
        trigger: 'change'
      }]
    });
    _defineProperty(_this, "therapistList", []);
    _defineProperty(_this, "therapistListLoading", true);
    _defineProperty(_this, "therapistListInfo", {
      total: 0,
      page: 1,
      limit: 10,
      organizationId: 0,
      organizationName: '',
      therapistName: ''
    });
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getList();
    }
    /**
     * Organization Type Text 반환
     */
  }, {
    key: "getTypeText",
    value: function getTypeText(type) {
      var value = this.typeOptions.filter(function (i) {
        return i.key === type;
      })[0];
      return value.display + '(' + value.key + ')';
    }
    /**
     * Organization Use Y/N Text 반환
     */
  }, {
    key: "getUseYnText",
    value: function getUseYnText(useYn) {
      var value = this.useYnOptions.filter(function (i) {
        return i.key === useYn;
      })[0];
      return value.display + '(' + value.key + ')';
    }
    /**
     * Organization 목록 조회
     */
  }, {
    key: "getList",
    value: (function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.orgListLoading = true;
              _context.p = 1;
              _context.n = 2;
              return getOrganizationList();
            case 2:
              data = _context.v;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              data = [];
            case 4:
              if (data.status === undefined) {
                this.organizationList = data;
              } else {
                this.organizationList = [];
              }
              this.orgListLoading = false;
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }()
    /**
     * Organization 정보수정
     */
    )
  }, {
    key: "editOrganization",
    value: (function () {
      var _editOrganization = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var id, params;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              id = row.id;
              params = {
                name: trim(row.name),
                type: row.type,
                useYn: row.useYn,
                clinicCode: row.clinicCode.toUpperCase()
              };
              if (!this.validateListData(row)) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return updateOrganization(id, params);
            case 1:
              this.getList();
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function editOrganization(_x) {
        return _editOrganization.apply(this, arguments);
      }
      return editOrganization;
    }()
    /**
     * Organization 목록 데이터 검증
     * @param row
     */
    )
  }, {
    key: "validateListData",
    value: function validateListData(row) {
      // 대문자 + 숫자 조합 정규식 21.02.01
      var regExpIsClincCode = /^(?=.*[A-Z])(?=.*\d)[A-Z\d]/;
      var isValidationErrorByClincCode = {
        pattern: false,
        length: false
      };
      !regExpIsClincCode.test(row.clinicCode) ? isValidationErrorByClincCode.pattern = true : isValidationErrorByClincCode.pattern = false;
      row.clinicCode.length !== 6 ? isValidationErrorByClincCode.length = true : isValidationErrorByClincCode.length = false;
      if (!row.name || trim(row.name) === '') {
        this.$message({
          message: 'Name is required',
          type: 'warning'
        });
        return false;
      }
      if (row.name.length < 3 || row.name.length > 100) {
        this.$message({
          message: 'Name Length should be 3 to 100',
          type: 'warning'
        });
        return false;
      }
      if (!row.type) {
        this.$message({
          message: 'Type is required',
          type: 'warning'
        });
        return false;
      }
      if (!row.clinicCode) {
        this.$message({
          message: 'Clinic Code is required',
          type: 'warning'
        });
        return false;
      }
      if (isValidationErrorByClincCode.pattern) {
        this.$message({
          message: 'Clinic code must be entered in capital letters and digit.',
          type: 'warning'
        });
        return false;
      }
      if (isValidationErrorByClincCode.length) {
        this.$message({
          message: 'Clinic code must be entered in 6 letters.',
          type: 'warning'
        });
        return false;
      }
      if (row.useYn === '') {
        this.$message({
          message: 'Use Y/N is required',
          type: 'warning'
        });
        return false;
      }
      return true;
    }
    /**
     * Organization 등록 시 데이터 초기화
     */
  }, {
    key: "resetTempOrganization",
    value: function resetTempOrganization() {
      this.tempOrganization = cloneDeep(defaultOrganization);
    }
    /**
     * Organization 등록 Layer 팝업 호출
     */
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      var _this2 = this;
      this.resetTempOrganization();
      this.dialogAddOrgVisible = true;
      this.$nextTick(function () {
        _this2.$refs['dataForm'].clearValidate();
      });
    }
    /**
     * Organization 등록 처리
     */
  }, {
    key: "createOrganization",
    value: (function () {
      var _createOrganization2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this3 = this;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.$refs['dataForm'].validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(valid) {
                  var params;
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.n) {
                      case 0:
                        if (!valid) {
                          _context3.n = 2;
                          break;
                        }
                        params = {
                          name: trim(_this3.tempOrganization.name),
                          type: _this3.tempOrganization.type,
                          clinicCode: _this3.tempOrganization.clinicCode,
                          useYn: _this3.tempOrganization.useYn
                        };
                        if (!_this3.validateListData(_this3.tempOrganization)) {
                          _context3.n = 2;
                          break;
                        }
                        _context3.n = 1;
                        return _createOrganization(params);
                      case 1:
                        _this3.getList();
                        _this3.dialogAddOrgVisible = false;
                        _this3.$notify({
                          title: 'Success',
                          message: 'Success created',
                          type: 'success',
                          duration: 2000
                        });
                      case 2:
                        return _context3.a(2);
                    }
                  }, _callee3);
                }));
                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function createOrganization() {
        return _createOrganization2.apply(this, arguments);
      }
      return createOrganization;
    }()
    /**
     * Manage Owner Layer 팝업 호출
     */
    )
  }, {
    key: "handleMngOwner",
    value: function handleMngOwner(row) {
      this.dialogMngOwnerVisible = true;
      this.therapistListInfo.page = 1;
      this.therapistListInfo.limit = 10;
      this.therapistListInfo.organizationName = row.name;
      this.therapistListInfo.therapistName = '';
      this.getTherapistListByOrg(row.id);
    }
    /**
     * Organization 에 속한 치료사 목록 조회
     */
  }, {
    key: "getTherapistListByOrg",
    value: (function () {
      var _getTherapistListByOrg2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(organizationId) {
        var _this4 = this;
        var data, params, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              this.therapistListLoading = true;
              this.therapistListInfo.organizationId = organizationId;
              _context5.p = 1;
              params = {
                page: this.therapistListInfo.page,
                size: this.therapistListInfo.limit,
                name: this.therapistListInfo.therapistName
              };
              _context5.n = 2;
              return _getTherapistListByOrg(organizationId, params);
            case 2:
              data = _context5.v;
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t2 = _context5.v;
              data = [];
            case 4:
              if (data.status === undefined) {
                this.therapistList = data.items;
                this.therapistListInfo.total = data.total_count;
                this.therapistList.map(function (v) {
                  _this4.$set(v, 'organizationId', organizationId);
                  var length = v.roleType.length;
                  var roleTypeText = '';
                  if (v.roleType.startsWith('SYS')) {
                    roleTypeText = 'Main Owner';
                  } else {
                    roleTypeText = v.roleType.charAt(0) + v.roleType.substring(1, length).toLowerCase();
                  }
                  _this4.$set(v, 'roleTypeText', roleTypeText);
                  length = v.gender.length;
                  _this4.$set(v, 'genderText', v.gender.charAt(0) + v.gender.substring(1, length).toLowerCase());
                });
              } else {
                this.therapistList = [];
                this.therapistListInfo.total = 0;
              }
              this.therapistListLoading = false;
            case 5:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function getTherapistListByOrg(_x3) {
        return _getTherapistListByOrg2.apply(this, arguments);
      }
      return getTherapistListByOrg;
    }()
    /**
     * Role Type Owner 로 전환
     * @param row
     */
    )
  }, {
    key: "toOwnerRole",
    value: (function () {
      var _toOwnerRole = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(row) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return toRoleTypeOwner(row.organizationId, row.id);
            case 1:
              this.getTherapistListByOrg(row.organizationId);
              this.$notify({
                title: 'Success',
                message: 'Success change Role Type to Owner',
                type: 'success',
                duration: 2000
              });
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function toOwnerRole(_x4) {
        return _toOwnerRole.apply(this, arguments);
      }
      return toOwnerRole;
    }()
    /**
     * Role Type Normal 로 전환
     * @param row
     */
    )
  }, {
    key: "toNormalRole",
    value: (function () {
      var _toNormalRole = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(row) {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return toRoleTypeNormal(row.organizationId, row.id);
            case 1:
              this.getTherapistListByOrg(row.organizationId);
              this.$notify({
                title: 'Success',
                message: 'Success change Role Type to Normal',
                type: 'success',
                duration: 2000
              });
            case 2:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function toNormalRole(_x5) {
        return _toNormalRole.apply(this, arguments);
      }
      return toNormalRole;
    }())
  }]);
}(Vue);
default_1 = __decorate([Component({
  name: 'OrganizationList',
  components: {
    Pagination: Pagination
  }
})], default_1);
export default default_1;